export const DummyTessituraTransaction = JSON.parse(`
{
    "batch": {
        "no": 132264,
        "type": 21,
        "typeName": "Controlled Batch Type",
        "status": "P"
    },
    "posting": {
        "no": 45482,
        "date": "2024-09-18T00:00:00",
        "by": "vhernand"
    },
    "transaction": {
        "sequenceNo": 4109536,
        "no": 2512593,
        "refNo": 1408037,
        "type": 1,
        "typeName": "Gift",
        "date": "2024-09-18T00:00:00",
        "amount": 15.0000,
        "amountSign": "P",
        "campaignNo": 876,
        "appealNo": 1083,
        "sourceNo": 11632,
        "mediaType": 1,
        "fundNo": 323,
        "feeNo": null,
        "pmapNo": null,
        "orderNo": null,
        "perfNo": 0,
        "tcktFlag": null,
        "createdBy": "vhernand"
    },
    "payment": {
        "date": "2024-09-18T00:00:00",
        "amount": 15.0000,
        "amountSign": "P",
        "refundDate": null,
        "method": "19"
    },
    "paymentMethod": {
        "name": "On Account Development",
        "shortName": "On Account",
        "actType": null,
        "irInd": "B",
        "checkInd": "N",
        "assetGlNo": "01-9001-2203-0152",
        "bu": "1",
        "merchantId": null,
        "pmtType": "2",
        "pmtMethodGroup": "4",
        "currencyType": null,
        "giftAidInd": "N",
        "typeName": "On Account",
        "assetGlName": "ON ACCT - DEVELOPMENT"
    },
    "paymentCustomer": {
        "no": 3023359,
        "custType": "1",
        "custGroup": null,
        "sortName": "Chase/Ilona"
    },
    "performance": {
        "no": 0,
        "code": "0PERF",
        "date": "1971-10-17T00:00:00",
        "name": "Zero Inventory",
        "seasonNo": "0",
        "season": "System Default Season",
        "priceLayerType": null,
        "priceLayer": null,
        "priceType": null,
        "priceTypeDesigCode": null,
        "priceTypeTicketDesignNo": null,
        "priceTypeGlNo": null,
        "priceTypeGlName": null,
        "priceTypeResaleGlNo": null,
        "priceTypeResaleGlName": null
    },
    "fee": {
        "name": null,
        "seasonNo": null,
        "desigCode": null,
        "glno": null,
        "glName": null
    },
    "fund": {
        "name": "AFD - General Fund",
        "desigCode": "1",
        "nonRestrictedIncomeGlNo": "01-9550-4700",
        "nonRestrictedIncomeGlName": "AFD - General Fund",
        "restrictedIncomeGlNo": "01-9550-4700",
        "restrictedIncomeGlName": "AFD - General Fund",
        "currentRecGlNo": "01-9001-1101",
        "currentRecGlName": "A/R CONTRIBUTED INCOME",
        "futureRecGlNo": "01-9001-1101",
        "futureRecGlName": "A/R CONTRIBUTED INCOME"
    },
    "contribution": {
        "date": "2024-09-18T00:00:00",
        "pledgeStartDate": null,
        "pledgeEndDate": null,
        "designation": "FY25GENERAL"
    },
    "contributionCustomer": {
        "no": 3023359,
        "custType": "1",
        "custGroup": null,
        "sortName": "Chase/Ilona"
    },
    "order": {
        "date": null,
        "deliveryDate": null
    },
    "orderCustomer": {
        "no": null,
        "custType": null,
        "custGroup": null,
        "sortName": null
    },
    "campaign": {
        "name": "FY25 Annual Support",
        "fiscalYear": 2025,
        "startDate": "2024-08-01T00:00:00",
        "endDate": "2025-07-31T00:00:00"
    }
}
    `);
